module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms6ke"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms6keIndex,
      "searchBoxAlias": "request-subrogate",
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "deleteInlineEventBool": true,
      "deleteInlineBtnDisp": false,
      "saveInlineEvent": _vm.callDelete
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), (_vm.detailDisp) ? _c('detail', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.currentDtereq,
      "currentNumseq": _vm.detail.numseq,
      "currentCodempid": _vm.codempid,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "eventBtn": _vm.eventBtn,
      "postHrms6keSave": _vm.postHrms6keSave,
      "indexSelected": _vm.indexSelected,
      "arrCodrem": _vm.dropdowns.codrem,
      "descCodapp": _vm.dash.descCodapp,
      "detailTab2Table": _vm.columns[_vm.app.nowLang].detailTab2Table,
      "receivedHrms6keDetailTab2Process": _vm.receivedHrms6keDetailTab2Process,
      "receivedHrms6keDetailTab2ProcessCodempid": _vm.receivedHrms6keDetailTab2ProcessCodempid,
      "receivedHrms6keDetailAddInline": _vm.receivedHrms6keDetailAddInline,
      "detailTab2InlineData": _vm.detailTab2InlineData,
      "searchIndex": _vm.searchParams,
      "setDetailInlineData": _vm.setDetailInlineData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f66ef32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms6ke/component.vue
// module id = 3851
// module chunks = 1